/**
 * Application entry point: mount the React shell.
 */

import './styles.css';

import { createRoot } from 'react-dom/client';

import { AppComponent } from './app-component.js';

const rootElement = document.getElementById('root');

if (rootElement === null) {
	throw new Error('player-web: #root element is missing from index.html');
}

createRoot(rootElement).render(<AppComponent />);
